import React from 'react';

const Results: React.FC = () => {
  const results = [
    {
      id: 1,
      category: '製造業',
      title: 'コーポレートサイト制作',
      description: '老舗製造業のブランドイメージを刷新。モダンなデザインと充実したコンテンツで、問い合わせ数が3倍に増加しました。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20corporate%20website%20mockup%20elegant%20modern%20interface%20design%20sophisticated%20layout%20professional%20atmosphere%20no%20people&width=700&height=500&seq=result-corporate-3401&orientation=landscape',
      tags: ['Webサイト', 'ブランディング', 'SEO']
    },
    {
      id: 2,
      category: '小売業',
      title: 'ECサイト構築・運営',
      description: '地域密着型の小売店のオンライン展開をサポート。使いやすいECサイトとSNS連動で、売上が前年比200%を達成しました。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20e-commerce%20platform%20interface%20product%20grid%20shopping%20cart%20elegant%20modern%20design%20sophisticated%20atmosphere%20no%20people&width=700&height=500&seq=result-ecommerce-3402&orientation=landscape',
      tags: ['ECサイト', 'SNS運営', '売上向上']
    },
    {
      id: 3,
      category: '飲食業',
      title: 'SNS運用・動画制作',
      description: 'レストランの魅力を動画で発信。プロフェッショナルな映像とストーリー性のある投稿で、フォロワー数が10倍に増加しました。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20video%20production%20concept%20film%20reel%20play%20button%20elegant%20modern%20design%20sophisticated%20atmosphere%20no%20people&width=700&height=500&seq=result-video-3403&orientation=landscape',
      tags: ['動画制作', 'SNS', 'ブランディング']
    },
    {
      id: 4,
      category: 'IT企業',
      title: 'オウンドメディア構築',
      description: 'IT企業の技術ブログを立ち上げ。SEO対策とコンテンツマーケティングで、月間PV数が50万を突破しました。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20blog%20media%20platform%20interface%20article%20layout%20elegant%20modern%20design%20sophisticated%20typography%20no%20people&width=700&height=500&seq=result-media-3404&orientation=landscape',
      tags: ['オウンドメディア', 'SEO', 'コンテンツ']
    },
    {
      id: 5,
      category: '美容サロン',
      title: 'ブランディング・Web制作',
      description: '高級美容サロンのブランドイメージを確立。洗練されたWebサイトとSNS戦略で、新規顧客が月50名増加しました。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20luxury%20brand%20identity%20elegant%20geometric%20patterns%20sophisticated%20modern%20design%20premium%20atmosphere%20no%20people&width=700&height=500&seq=result-branding-3405&orientation=landscape',
      tags: ['ブランディング', 'Webサイト', 'SNS']
    },
    {
      id: 6,
      category: '教育事業',
      title: 'サブスクリプションサービス',
      description: 'オンライン学習プラットフォームを構築。使いやすいUIと充実したコンテンツで、会員数が1年で5,000名を突破しました。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20online%20learning%20platform%20interface%20course%20modules%20elegant%20modern%20design%20sophisticated%20atmosphere%20no%20people&width=700&height=500&seq=result-education-3406&orientation=landscape',
      tags: ['サブスク', 'プラットフォーム', 'UI/UX']
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-purple-50 to-white relative overflow-hidden" id="results">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-purple-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-fuchsia-600 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6 px-8 py-3 bg-gradient-to-r from-purple-900 to-violet-900 rounded-full border-2 border-fuchsia-400">
            <span className="text-purple-100 text-sm font-black tracking-widest" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
              CASE STUDIES
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-purple-900 mb-6" style={{ fontFamily: '"Shippori Mincho", serif' }}>
            導入実績
          </h2>
          <p className="text-xl text-stone-700 max-w-3xl mx-auto leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
            様々な業界のお客様に、確かな成果をお届けしています
          </p>
        </div>

        {/* マソンリー風レイアウト */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {results.map((result, index) => (
            <div 
              key={result.id}
              className={`group ${index === 0 || index === 5 ? 'md:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 border-2 border-purple-100 hover:border-fuchsia-400 h-full flex flex-col hover:-translate-y-2">
                {/* 画像部分 */}
                <div className="h-64 overflow-hidden relative">
                  <img 
                    src={result.image} 
                    alt={result.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-purple-900 via-purple-900/50 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-500"></div>
                  
                  {/* カテゴリーバッジ */}
                  <div className="absolute top-6 left-6">
                    <span className="px-6 py-2 bg-gradient-to-r from-fuchsia-500 to-violet-500 text-white text-sm font-black rounded-full border-2 border-white/30 shadow-xl" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                      {result.category}
                    </span>
                  </div>
                </div>

                {/* テキスト部分 */}
                <div className="p-8 flex-1 flex flex-col">
                  <h3 className="text-2xl font-black text-purple-900 mb-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                    {result.title}
                  </h3>
                  <p className="text-stone-700 leading-relaxed mb-6 flex-1 font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                    {result.description}
                  </p>
                  
                  {/* タグ */}
                  <div className="flex flex-wrap gap-2">
                    {result.tags.map((tag, tagIndex) => (
                      <span 
                        key={tagIndex}
                        className="px-4 py-2 bg-purple-50 text-purple-900 text-sm font-black rounded-full border border-purple-200" 
                        style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Results;
